import { ClientReviewResponse } from '@vestico/model';

export const getResponseElementID = (response: ClientReviewResponse) => {
  return `post-${response.postDocumentID}`;
};
